import React from 'react';
import { FieldGroup } from '../../components';

export function PlanAmount({ feature, plan, value }) {
  return (
    <div className={`plan-amount ${value === -1 ? 'unlimited' : ''}`}>
      <FieldGroup
        name={`${feature}.${plan}`}
        type="number"
        min={-1}
      />
      <span className={`unlimited-amount`}>Unlimited</span>
    </div>
  );
}
